const s = {
  name: "Cat",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,15h4v2h-4V15z"/>
		<path class="st0" d="M28,13.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,12.7,27.3,13.2,28,13.2z"
			/>
		<path class="st0" d="M35.3,12c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C34.7,10.7,35.3,11.3,35.3,12z"
			/>
		<path class="st0" d="M28.3,5h5.3L40,0v14c0,3.1-1.6,5.9-4,7.5V40H6v-0.1c-3.4-0.5-6-3.4-6-6.9c0-4.1,1.1-8.1,3.2-11.7l2.2-3.6
			C7.6,14,8.2,9.5,7,5.3L9,4.7c1.4,4.7,0.7,9.8-1.9,14l-2.2,3.6C3,25.6,2,29.3,2,33c0,2.4,1.7,4.4,4,4.9V32
			c0-9.1,7.1-16.5,16.1-16.9c0-0.4-0.1-0.7-0.1-1.1V0L28.3,5z M31,38h3V22.5c-0.9,0.3-2,0.5-3,0.5c-3.9,0-7.2-2.5-8.5-6
			C14.5,17.3,8,23.9,8,32v6h11.4c-0.4-1.7-2-3-3.9-3H11v-2h4.5c3,0,5.4,2.2,5.9,5H24V27h2v11h3V27h2V38z M31,21c3.9,0,7-3.1,7-7h0
			V4.1L34.3,7h-6.7L24,4.1V14C24,17.9,27.1,21,31,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Cat
};
